import $ from 'jquery'

const partHeroCtaContainer = $('.part-hero-cta__container');
const partHeroCtaWrapper = $('.part-hero-cta__wrapper');
const partHeroCtaContentContainer = $('.part-hero-cta__content-container');

partHeroCtaContentContainer.css('height', partHeroCtaContentContainer.height())

$('.js-close-hero-cta').on('click', function () {
    partHeroCtaWrapper.addClass('part-hero-cta__wrapper--closed')
    partHeroCtaContainer.addClass('part-hero-cta__container--closed')
})

partHeroCtaWrapper.on('click', function () {
    if ($(this).hasClass('part-hero-cta__wrapper--closed')) {
        event.preventDefault();
        event.stopPropagation();
        $(this).removeClass('part-hero-cta__wrapper--closed')
        partHeroCtaContainer.removeClass('part-hero-cta__container--closed')
    }
})
